import React, { useState, useMemo, useRef, useEffect } from 'react'
import { Input, Select, TimePicker, Switch, Button, Tabs, Tooltip, Popconfirm, message } from 'antd'
import moment from 'moment'
import ListCondition from "./ListCondition"
import { CloseOutlined, DoubleRightOutlined, QuestionCircleOutlined, MenuOutlined, DeleteOutlined, PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { daysOfWeek } from '../../constant/config'
import { v4 as uuidV4 } from 'uuid'

const ScheduleRow = (props) => {
    const {
        key,
        scheduleItem,
        validate,
        onChangeSchedules,
        isMultiVariants,
        isFit,
        allPartners,
        isMultiFrames,
        handleDragEnd,
        sizeFrames,
        sizeOfRawMaterials,
        optionPartner,
        setSchedules,
        addCondition,
        onChangeRecord,
        onAddSizeFrames,
        removeRecord,
        addFitCondition,
        removeFitCondition,
        schedules,
        onAddSizeRawMaterials,
        setEditingValue,
        editingValue,
    } = props

    const {
        variants = [],
        fit_condition: fitCondition = {},
        days_of_week = [],
        times = []
    } = Object.assign({}, scheduleItem)

    const [editingKey, setEditingKey] = useState(null)
    const [searchValue, setSearchValue] = useState("")
    const [activeKey, setActiveKey] = useState('1')

    const selectRef = useRef(null)
    const timeoutRef = useRef(null)

    const currentVariant = useMemo(() => variants.find(variant => variant.key === activeKey) || {}, [activeKey, variants])
    const { sizes = [], conditions = [], min_variant_quantity = null, is_multi_sizes = false } = Object.assign({}, currentVariant)

    const {
        frames = [],
        coverages = [],
    } = Object.assign({}, fitCondition)

    const listFramesFit = useMemo(() => frames.map(f => !!f.label && f.label), [frames])

    useEffect(() => {
        !isMultiVariants && setActiveKey('1')
    }, [isMultiVariants])

    const handleSearchFitCondition = (value) => {
        setSearchValue(value)

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }

        timeoutRef.current = setTimeout(() => {
            const isValidFormat = /^\d+x\d+$/.test(value)
            if (!isValidFormat) return

            if (!sizeOfRawMaterials.some(opt => opt.label === value)) {
                const [w, h] = value.split("x")
                const newValue = { label: `${w}x${h}`, w, h }
                onAddSizeRawMaterials(newValue)
            }
        }, 500)
    }

    const handleKeyDownFitCondition = (e, conditionId, filed, fieldParent) => {
        if (e.key === "Enter") {
            onChangeSchedules({
                scheduleIdx: scheduleItem.idx,
                fieldSchedule: "fit_condition",
                valueSchedule: null,
                fitCondition: {
                    idxCondition: conditionId,
                    fieldFit: filed,
                    valueFit: searchValue,
                    fieldParent
                },
                variant: {}
            })
        }
    }

    const handleAddTab = (scheduleIdx) => {
        const newKey = (variants.length + 1).toString()
        const newTab = {
            key: newKey,
            name: "",
            sizes: [],
            min_variant_quantity: null,
            conditions: [],
        }

        setSchedules(preSchedules => {
            return preSchedules.map(scheduleItem => {
                if (scheduleIdx === scheduleItem.idx) {
                    const { variants = [] } = Object.assign({}, scheduleItem)
                    return {
                        ...scheduleItem,
                        variants: [...variants, newTab]
                    }
                }

                return scheduleItem
            })
        })
        setEditingKey(newKey)
        setEditingValue("")
    }

    const handleRemoveTab = (scheduleIdx, key) => {
        setSchedules(preSchedules => {
            return preSchedules.map(scheduleItem => {
                if (scheduleIdx === scheduleItem.idx) {
                    const { variants = [] } = Object.assign({}, scheduleItem)
                    const newVariants = variants.filter((tab) => tab.key !== key) || []
                    if (key === activeKey && !!newVariants.length) setActiveKey(newVariants[0].key)

                    return {
                        ...scheduleItem,
                        variants: newVariants
                    }
                }

                return scheduleItem
            })
        })
    }

    const handleDoubleClick = (key, title) => {
        setEditingKey(key)
        setEditingValue(title)
    }

    const handleChange = (e) => {
        setEditingValue(e.target.value)
    }

    const handleBlur = (scheduleIdx) => {
        if (!!editingValue && editingValue.trim().length > 50) return message.error('Tên variant tối đa 50 kí tự.')
        setSchedules(preSchedules => {
            return preSchedules.map(scheduleItem => {
                if (scheduleIdx === scheduleItem.idx) {
                    const { variants = [] } = Object.assign({}, scheduleItem)
                    const newVariants = variants.map(variant => {
                        return variant.key === editingKey ? { ...variant, name: editingValue ? editingValue.trim() : 'New' } : variant
                    })
                    return {
                        ...scheduleItem,
                        variants: newVariants
                    }
                }

                return scheduleItem
            })
        })
        setEditingKey(null)
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            if (editingValue.trim() !== "") {
                handleBlur(scheduleItem.idx)
            }
        }
    }

    const handleKeyDownVariant = (event) => {
        if (event.key === "Enter" && event.target.value.trim() !== "") {
            const newValue = [...sizes, event.target.value.trim()]
            onChangeSchedules({
                scheduleIdx: scheduleItem.idx,
                fieldSchedule: "variants",
                valueSchedule: null,
                fitCondition: {},
                variant: {
                    tabKey: activeKey,
                    fieldVariant: "sizes",
                    valueVariant: newValue
                }
            })
            event.preventDefault()
            selectRef.current.blur()
            setTimeout(() => selectRef.current.focus(), 300)
        }
    }

    const callback = (key) => {
        setActiveKey(key)
    }

    const addScheduleTime = (scheduleIdx, action = '', timeIdx) => {
        setSchedules(preSchedules => {
            return preSchedules.map(schedule => {
                if (scheduleIdx === schedule.idx) {
                    const { times = [] } = Object.assign({}, schedule)
                    if (action === 'add') {
                        const newTime = {
                            idx: uuidV4(),
                            start: ''
                        }
                        const newTimes = [...times, newTime]

                        return {
                            ...schedule,
                            times: newTimes
                        }
                    }

                    if (action === "delete") {
                        const newTimes = times.filter(time => time.idx !== timeIdx)
                        return {
                            ...schedule,
                            times: newTimes
                        }
                    }
                }

                return schedule
            })
        })
    }

    const deleteSchedule = (scheduleIdx) => {
        setSchedules(preSchedules => {
            return preSchedules.filter(schedule => schedule.idx !== scheduleIdx)
        })
    }

    return (
        <div className='list-schedules py-3' key={key}>
            <div className="row mb-4">
                <div className="schedule col-12">
                    <div className="d-flex align-items-center justify-content-between">
                        <label className="d-block" style={{ fontSize: '18px' }}>Schedule <span className="text-danger">*</span></label>
                        {schedules.length > 1 &&
                            <Popconfirm
                                placement='topRight'
                                title="Chắc chắn xóa schedule này?"
                                onConfirm={() => deleteSchedule(scheduleItem.idx)}
                            >
                                <Button type='danger' >Xóa schedule</Button>
                            </Popconfirm>
                        }
                    </div>
                    <div className="list-schedules-time">
                        {
                            times.map((time, index) => {
                                return (
                                    <div className="schedule-item" key={index}>
                                        {
                                            index === 0 ?
                                                <Select
                                                    placeholder="Thứ *"
                                                    value={days_of_week.map(i => i.day) || []}
                                                    style={{ width: '50%', marginRight: '24px' }}
                                                    onChange={(value) => onChangeSchedules({
                                                        scheduleIdx: scheduleItem.idx,
                                                        fieldSchedule: "days_of_week",
                                                        valueSchedule: value,
                                                        fitCondition: {},
                                                        variant: {}
                                                    })}
                                                    allowClear
                                                    mode="multiple"
                                                    showSearch
                                                >
                                                    {daysOfWeek.map((day) => (
                                                        <Select.Option key={day.value} value={day.value}>
                                                            {day.label}
                                                        </Select.Option>
                                                    ))}
                                                </Select> :
                                                <div style={{ width: '50%', marginRight: '24px' }}></div>
                                        }
                                        <TimePicker
                                            format="HH:mm"
                                            // className={`${(!!validate.start && validate.start.length > 0) ? 'Error' : ''}`}
                                            value={!!time.start ? moment(time.start, "HH:mm") : undefined}
                                            onChange={(e, value) => onChangeSchedules({
                                                scheduleIdx: scheduleItem.idx,
                                                fieldSchedule: "times",
                                                valueSchedule: value,
                                                fitCondition: {},
                                                variant: {},
                                                timeItem: {
                                                    field: 'start',
                                                    timeIdx: time.idx
                                                }
                                            })}
                                            placeholder='Bắt đầu *'
                                            style={{ width: '10%', marginRight: '24px' }}
                                        />
                                        <span style={{ marginRight: '24px', fontSize: '16px', fontWeight: 600 }}>-</span>
                                        <TimePicker
                                            format="HH:mm"
                                            // className={`${(!!validate.end && validate.end.length > 0) ? 'Error' : ''}`}
                                            value={!!time.end ? moment(time.end, "HH:mm") : undefined}
                                            onChange={(e, value) => onChangeSchedules({
                                                scheduleIdx: scheduleItem.idx,
                                                fieldSchedule: "times",
                                                valueSchedule: value,
                                                fitCondition: {},
                                                variant: {},
                                                timeItem: {
                                                    field: 'end',
                                                    timeIdx: time.idx
                                                }
                                            })}
                                            placeholder='Kết thúc'
                                            style={{ width: '10%', marginRight: '24px' }}
                                        />
                                        {
                                            times.length > 1 &&
                                            <DeleteOutlined
                                                className='cursor-pointer mr-2'
                                                onClick={() => addScheduleTime(scheduleItem.idx, 'delete', time.idx)}
                                            />
                                        }

                                        {
                                            times.length === index + 1 &&
                                            <PlusCircleOutlined
                                                className='cursor-pointer'
                                                onClick={() => addScheduleTime(scheduleItem.idx, 'add')}
                                            />
                                        }

                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                {
                    !!validate.end && validate.end.length > 0 &&
                    <label className="Validate mb-0 w-100">{validate.end}</label>
                }
            </div>
            {
                !isFit && isMultiVariants &&
                <React.Fragment>
                    <div className="row col-12 flex-column">
                        <label className="d-block" style={{ fontSize: '18px' }}>Variant</label>
                        <div className="list-variants">
                            <Tabs onChange={callback} type="card">
                                {
                                    variants.map((variant) => {
                                        return (
                                            <Tabs.TabPane
                                                tab={
                                                    editingKey === variant.key ? (
                                                        <Input
                                                            size="small"
                                                            style={{ width: '100px' }}
                                                            value={editingValue}
                                                            onChange={handleChange}
                                                            onBlur={() => handleBlur(scheduleItem.idx)}
                                                            onKeyDown={handleKeyDown}
                                                            autoFocus
                                                        />
                                                    ) : (
                                                        <span
                                                            className='px-0 d-flex align-items-center'
                                                            style={{ fontWeight: 600 }}
                                                            onDoubleClick={() => handleDoubleClick(variant.key, variant.name)}
                                                        >
                                                            {variant.name || 'New'}{variants.length > 1 && <CloseOutlined className='ml-2' onClick={(e) => {
                                                                e.stopPropagation()
                                                                handleRemoveTab(scheduleItem.idx, variant.key)
                                                            }} />}
                                                        </span>
                                                    )
                                                }
                                                key={variant.key}
                                            />
                                        )
                                    })
                                }
                                <Tabs.TabPane
                                    tab={
                                        <Button
                                            type="dashed"
                                            style={{ border: "none", background: "transparent" }}
                                            className='px-0'
                                            onClick={() => handleAddTab(scheduleItem.idx)}
                                        >
                                            + Thêm variant
                                        </Button>
                                    }
                                    key="add-tab"
                                    disabled
                                />
                            </Tabs>
                        </div>
                    </div>
                    {
                        !!currentVariant.name &&
                        <div className="row mb-3 col-12 d-flex align-items-center">
                            <div className="col-1 multiBrand d-flex align-items-center px-0">
                                <Tooltip
                                    title={is_multi_sizes ? 'Lô tạo thành chứa nhiều size' : 'Lô tạo thành chỉ chứa 1 size'}
                                    className='d-flex align-items-center'
                                >
                                    <label className="d-block mb-0">Sizes</label>
                                    <Switch
                                        className="ml-2"
                                        checked={is_multi_sizes}
                                        onChange={() => onChangeSchedules({
                                            scheduleIdx: scheduleItem.idx,
                                            fieldSchedule: "variants",
                                            valueSchedule: null,
                                            fitCondition: {},
                                            variant: {
                                                tabKey: activeKey,
                                                fieldVariant: "is_multi_sizes",
                                                valueVariant: !is_multi_sizes
                                            }
                                        })}
                                    />
                                </Tooltip>
                            </div>
                            <div className="list-variant col-11 d-flex align-items-center justify-content-between px-0">
                                <label className="d-flex align-items-center mb-0 pl-3" style={{ color: '#d3d5d7', fontWeight: 'normal' }}>
                                    Danh sách variant<DoubleRightOutlined className='ml-3' />
                                </label>
                                <Select
                                    ref={selectRef}
                                    style={{ width: '80%' }}
                                    className='custom-select-variant'
                                    value={sizes || []}
                                    placeholder="Nhập variant"
                                    tokenSeparators={[',']}
                                    mode="tags"
                                    onChange={(value) => onChangeSchedules({
                                        scheduleIdx: scheduleItem.idx,
                                        fieldSchedule: "variants",
                                        valueSchedule: null,
                                        fitCondition: {},
                                        variant: {
                                            tabKey: activeKey,
                                            fieldVariant: "sizes",
                                            valueVariant: value
                                        }
                                    })}
                                    onInputKeyDown={handleKeyDownVariant}
                                    allowClear
                                    open={false}
                                />
                            </div>
                        </div>
                    }
                </React.Fragment>
            }

            <div className="row">
                <div className="required_tags col-12">
                    {
                        !isFit ?
                            (!!currentVariant.name || currentVariant.name === "__ALL_SIZE__") &&
                            <React.Fragment>
                                <div className="d-flex align-items-center mb-3">
                                    <label className="d-block mr-5" style={{ fontSize: '18px' }}>Chi tiết</label>
                                    {
                                        isMultiFrames &&
                                        <div className='d-flex align-items-center'>
                                            <label className="d-block mr-3" style={{ fontSize: '16px' }}>Số item tối thiểu</label>
                                            <Input
                                                type="number"
                                                min={1}
                                                style={{ width: '100px' }}
                                                value={min_variant_quantity}
                                                onChange={e => {
                                                    const value = e.target.value
                                                    if (/^\d+$/.test(value) && +value > 0) {
                                                        onChangeSchedules({
                                                            scheduleIdx: scheduleItem.idx,
                                                            fieldSchedule: "variants",
                                                            valueSchedule: null,
                                                            fitCondition: {},
                                                            variant: {
                                                                tabKey: activeKey,
                                                                fieldVariant: "min_variant_quantity",
                                                                valueVariant: +value
                                                            }
                                                        })
                                                    }
                                                }}
                                            />
                                            <Tooltip
                                                title='Lượng item tối thiểu để có thể tạo lô'
                                            ><QuestionCircleOutlined style={{ fontSize: '18px' }} className='ml-3 cursor-pointer' /></Tooltip>
                                        </div>
                                    }
                                </div>
                                <ListCondition
                                    conditions={conditions}
                                    partners={allPartners}
                                    removeRecord={removeRecord}
                                    addCondition={addCondition}
                                    onChangeSchedules={onChangeSchedules}
                                    onChangeRecord={onChangeRecord}
                                    isFit={isFit}
                                    activeKey={activeKey}
                                    isMultiFrames={isMultiFrames}
                                    handleDragEnd={handleDragEnd}
                                    onAddSizeFrames={onAddSizeFrames}
                                    sizeFrames={sizeFrames}
                                    scheduleItem={scheduleItem}
                                />
                            </React.Fragment>
                            :
                            <div className="row fit-condition d-flex">
                                <div className="col-4" style={{ borderRight: '1px dashed #bba8a8' }}>
                                    <table className="frames-table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Khổ nguyên vật liệu <span className="text-danger">*</span></th>
                                                <th>Enable</th>
                                            </tr>
                                        </thead>
                                        <DragDropContext onDragEnd={(result) => handleDragEnd(scheduleItem.idx, result, "frames")}>
                                            <Droppable droppableId="frames-list" direction="vertical">
                                                {(provided) => (
                                                    <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                                        {frames.map((fr, index) => (
                                                            <Draggable key={fr._idx} draggableId={String(fr._idx)} index={index}>
                                                                {(provided, snapshot) => (
                                                                    <tr
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        style={{
                                                                            ...provided.draggableProps.style
                                                                        }}
                                                                    >
                                                                        <td {...provided.dragHandleProps}>
                                                                            <MenuOutlined style={{ cursor: 'grab' }} />
                                                                        </td>
                                                                        <td>
                                                                            <Select
                                                                                placeholder="Chọn khổ"
                                                                                value={fr.label ? fr.label : []}
                                                                                allowClear
                                                                                onChange={(value) => onChangeSchedules({
                                                                                    scheduleIdx: scheduleItem.idx,
                                                                                    fieldSchedule: "fit_condition",
                                                                                    valueSchedule: null,
                                                                                    fitCondition: {
                                                                                        idxCondition: fr._idx,
                                                                                        fieldFit: 'type',
                                                                                        valueFit: value,
                                                                                        fieldParent: "frames"
                                                                                    },
                                                                                    variant: {}
                                                                                })}
                                                                                onSearch={handleSearchFitCondition}
                                                                                onInputKeyDown={e => handleKeyDownFitCondition(e, fr._idx, 'type', "frames")}
                                                                                style={{ width: '150px' }}
                                                                                showSearch
                                                                            >
                                                                                {
                                                                                    sizeOfRawMaterials.map((raw_material, i) => (
                                                                                        <Select.Option disabled={listFramesFit.includes(raw_material.label)} key={i} value={raw_material.label}>{raw_material.label}</Select.Option>
                                                                                    ))
                                                                                }
                                                                            </Select>
                                                                        </td>
                                                                        <td>
                                                                            <div className="d-flex align-items-center">
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    className='custom-enable mr-2'
                                                                                    checked={fr.is_enable}
                                                                                    onChange={() => onChangeSchedules({
                                                                                        scheduleIdx: scheduleItem.idx,
                                                                                        fieldSchedule: "fit_condition",
                                                                                        valueSchedule: null,
                                                                                        fitCondition: {
                                                                                            idxCondition: fr._idx,
                                                                                            fieldFit: 'is_enable',
                                                                                            valueFit: !fr.is_enable,
                                                                                            fieldParent: "frames"
                                                                                        },
                                                                                        variant: {}
                                                                                    })}
                                                                                />
                                                                                <Popconfirm
                                                                                    placement='topRight'
                                                                                    title="Xóa thông tin tạo lô cho đối tác này?"
                                                                                    onConfirm={() => removeFitCondition(scheduleItem.idx, "frames", fr._idx)}
                                                                                >
                                                                                    <DeleteOutlined
                                                                                        style={{ pointerEvents: frames.length <= 1 ? 'none' : 'unset', fontSize: '20px', cursor: 'pointer' }}
                                                                                    />
                                                                                </Popconfirm>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <PlusCircleOutlined
                                                                        style={{ marginLeft: '30px' }}
                                                                        onClick={() => addFitCondition(scheduleItem.idx, "frames")}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        {provided.placeholder}
                                                    </tbody>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </table>
                                </div>

                                <div className="col-8">
                                    <table className="coverages-table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Tỉ lệ phủ tối thiểu <span className="text-danger">*</span></th>
                                                <th>Partner <span className="text-danger">*</span></th>
                                            </tr>
                                        </thead>
                                        <DragDropContext onDragEnd={(result) => handleDragEnd(scheduleItem.idx, result, "coverages")}>
                                            <Droppable droppableId="coverages-list" direction="vertical">
                                                {(provided) => (
                                                    <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                                        {coverages.map((cr, index) => (
                                                            <Draggable key={cr._idx} draggableId={String(cr._idx)} index={index}>
                                                                {(provided, snapshot) => (
                                                                    <tr
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        style={{
                                                                            ...provided.draggableProps.style
                                                                        }}
                                                                    >
                                                                        <td {...provided.dragHandleProps}>
                                                                            <MenuOutlined style={{ cursor: 'grab' }} />
                                                                        </td>
                                                                        <td>
                                                                            <Input
                                                                                type="number"
                                                                                value={cr.rate}
                                                                                style={{ width: '200px' }}
                                                                                placeholder='Tỉ lệ'
                                                                                // onChange={e => onChangeFitCondition(cr._idx, 'rate', e.target.value, "coverages")}
                                                                                onChange={(e) => onChangeSchedules({
                                                                                    scheduleIdx: scheduleItem.idx,
                                                                                    fieldSchedule: "fit_condition",
                                                                                    valueSchedule: null,
                                                                                    fitCondition: {
                                                                                        idxCondition: cr._idx,
                                                                                        fieldFit: 'rate',
                                                                                        valueFit: e.target.value,
                                                                                        fieldParent: "coverages"
                                                                                    },
                                                                                    variant: {}
                                                                                })}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Select
                                                                                placeholder="Chọn partner"
                                                                                value={cr.partner || []}
                                                                                allowClear
                                                                                onChange={(value) => onChangeSchedules({
                                                                                    scheduleIdx: scheduleItem.idx,
                                                                                    fieldSchedule: "fit_condition",
                                                                                    valueSchedule: null,
                                                                                    fitCondition: {
                                                                                        idxCondition: cr._idx,
                                                                                        fieldFit: 'partner',
                                                                                        valueFit: value,
                                                                                        fieldParent: "coverages"
                                                                                    },
                                                                                    variant: {}
                                                                                })}
                                                                                style={{ width: '200px' }}
                                                                            >
                                                                                {!!optionPartner.length && optionPartner.map((i, index) => (
                                                                                    <Select.Option key={i._id} value={i._id}>{i.name}</Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                        </td>
                                                                        <td>
                                                                            <div className="d-flex align-items-center">
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    className='custom-enable mr-2'
                                                                                    checked={cr.is_enable}
                                                                                    onChange={() => onChangeSchedules({
                                                                                        scheduleIdx: scheduleItem.idx,
                                                                                        fieldSchedule: "fit_condition",
                                                                                        valueSchedule: null,
                                                                                        fitCondition: {
                                                                                            idxCondition: cr._idx,
                                                                                            fieldFit: 'is_enable',
                                                                                            valueFit: !cr.is_enable,
                                                                                            fieldParent: "coverages"
                                                                                        },
                                                                                        variant: {}
                                                                                    })}
                                                                                />
                                                                                <Popconfirm
                                                                                    placement='topRight'
                                                                                    title={`Xóa thông tin tạo lô cho đối tác này?`}
                                                                                    onConfirm={() => removeFitCondition(scheduleItem.idx, "coverages", cr._idx)}
                                                                                >
                                                                                    <DeleteOutlined style={{ pointerEvents: coverages.length <= 1 ? 'none' : 'unset', fontSize: '20px', cursor: 'pointer' }} />
                                                                                </Popconfirm>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <PlusCircleOutlined
                                                                        style={{ marginLeft: '30px' }}
                                                                        onClick={() => addFitCondition(scheduleItem.idx, "coverages")}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        {provided.placeholder}
                                                    </tbody>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </table>
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default ScheduleRow